<template>
  <div class="character-selection">
    <h1>Your Character</h1>
    
    <div class="character-container">
      <div 
        class="character-card selected"
      >
        <div class="character-image">
          <!-- Character model/image -->
          <div 
            class="character-model model-soldier"
          >
            <div class="character-shadow"></div>
          </div>
        </div>
        <div class="character-info">
          <h3>{{ characters[0].name }}</h3>
          <div class="character-stats">
            <div class="stat">
              <span class="stat-label">Health:</span>
              <div class="stat-bar">
                <div class="stat-fill" :style="{ width: (characters[0].health/150) * 100 + '%' }"></div>
              </div>
              <span class="stat-value">{{ characters[0].health }}</span>
            </div>
            <div class="stat">
              <span class="stat-label">Speed:</span>
              <div class="stat-bar">
                <div class="stat-fill" :style="{ width: (characters[0].speed/10) * 100 + '%' }"></div>
              </div>
              <span class="stat-value">{{ characters[0].speed }}</span>
            </div>
            <div class="stat">
              <span class="stat-label">Damage:</span>
              <div class="stat-bar">
                <div class="stat-fill" :style="{ width: (characters[0].damage/10) * 100 + '%' }"></div>
              </div>
              <span class="stat-value">{{ characters[0].damage }}</span>
            </div>
          </div>
          <p class="character-description">{{ characters[0].description }}</p>
          
          <div class="special-abilities">
            <h4>Special Abilities</h4>
            <ul>
              <li v-for="(ability, index) in characters[0].abilities" :key="index">
                <strong>{{ ability.name }}:</strong> {{ ability.description }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    
    <div class="username-input">
      <label for="username">Username (optional):</label>
      <input 
        type="text" 
        id="username" 
        v-model="username" 
        placeholder="Enter your username or leave blank for random ID" 
      />
      <div class="username-preview" v-if="displayName">
        You will play as: <strong>{{ displayName }}</strong>
      </div>
    </div>
    
    <div class="action-buttons">
      <button class="back-button" @click="goBack">Back</button>
      <button 
        class="start-button" 
        @click="startGame"
      >
        Start Game
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CharacterSelection',
  data() {
    return {
      username: '',
      randomId: Math.floor(1000 + Math.random() * 9000),
      characters: [
        {
          id: 'soldier',
          name: 'Soldier',
          health: 150,
          speed: 6,
          damage: 8,
          description: 'A well-rounded fighter with high health and good damage output. Specializes in assault rifles and heavy weapons.',
          abilities: [
            { name: 'Armor Boost', description: 'Temporarily increases damage resistance by 30%' },
            { name: 'Ammo Reserve', description: 'Carries 50% more ammunition than other characters' }
          ]
        }
      ],
      selectionSent: false
    };
  },
  computed: {
    displayName() {
      if (this.username.trim()) {
        return `${this.username.trim()}-${this.randomId}`;
      } else {
        return `Player-${this.randomId}`;
      }
    }
  },
  methods: {
    goBack() {
      console.log('Going back to main menu');
      this.$emit('go-back');
    },
    startGame() {
      const playerData = {
        username: this.displayName,
        character: 'soldier'
      };
      
      console.log('Starting game with:', playerData);
      
      if (!this.selectionSent) {
        this.selectionSent = true;
        this.$emit('start-game', playerData);
      }
    }
  },
  created() {
    this.randomId = Math.floor(1000 + Math.random() * 9000);
  }
};
</script>

<style scoped>
.character-selection {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px;
  font-family: 'Arial', sans-serif;
  color: #333;
  background-color: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

h1 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

.character-container {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.character-card {
  width: 500px;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  border: 3px solid #4caf50;
}

.character-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}

.character-card.selected {
  border: 3px solid #4caf50;
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.character-image {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  height: 180px;
}

.character-model {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.character-shadow {
  position: absolute;
  bottom: 0;
  width: 80%;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  filter: blur(3px);
}

.model-soldier {
  background-image: linear-gradient(135deg, #6a7b86, #373b44);
  position: relative;
}

.model-soldier::before {
  content: '';
  position: absolute;
  width: 60%;
  height: 60%;
  background-color: #444;
  border-radius: 50%;
  top: 25%;
  left: 20%;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
}

.character-info h3 {
  text-align: center;
  margin-bottom: 15px;
  color: #333;
}

.character-stats {
  margin-bottom: 15px;
}

.stat {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.stat-label {
  width: 70px;
  font-size: 14px;
  color: #666;
}

.stat-bar {
  flex: 1;
  height: 10px;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
  margin: 0 10px;
}

.stat-fill {
  height: 100%;
  background-color: #4caf50;
  border-radius: 5px;
}

.stat-value {
  width: 30px;
  text-align: right;
  font-size: 14px;
  color: #333;
}

.character-description {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  margin-bottom: 15px;
}

.special-abilities {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
}

.special-abilities h4 {
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 15px;
  color: #333;
}

.special-abilities ul {
  margin: 0;
  padding: 0 0 0 20px;
}

.special-abilities li {
  font-size: 13px;
  margin-bottom: 5px;
  color: #555;
}

.username-input {
  text-align: center;
  margin-bottom: 30px;
  position: relative;
}

.username-input label {
  margin-right: 10px;
  font-weight: bold;
}

.username-input input {
  padding: 12px 15px;
  width: 300px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.username-input input:focus {
  outline: none;
  border-color: #4caf50;
  box-shadow: 0 0 5px rgba(76, 175, 80, 0.3);
}

.username-preview {
  margin-top: 10px;
  padding: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  font-size: 14px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

button {
  padding: 12px 25px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
}

.back-button {
  background-color: #f5f5f5;
  color: #333;
}

.start-button {
  background-color: #4caf50;
  color: white;
}

button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

button:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}
</style> 